import { API_HEADERS } from '../constants/apiHeaders';
import api from '../utils/api';
import { USER_ENDPOINTS } from './endpoints/user.endpoints';
import type { UserProfileData, UserProfileUpdateRequest } from './types/userProfile.types';

type ProfileEnvelope = { data: UserProfileData; count: number };
type MessageResponse = { message: string };

export const userProfileService = {
  getProfile: () =>
    api.get<ProfileEnvelope>(USER_ENDPOINTS.profile, {
      headers: API_HEADERS.USER_PROFILE_GET,
    }),

  updateProfile: (data: UserProfileUpdateRequest) =>
    api.put<MessageResponse>(USER_ENDPOINTS.profile, data, {
      headers: API_HEADERS.USER_PROFILE_PUT,
    }),
};
